import { api } from '.';
import { HardwareRemoteRelay, RemoteRelay } from './hardwareApi';

type ToggleRemoteRelayPayload = {
    ipAddress: string;
    id: string;
    toggled: boolean;
};

const remoteRelayApi = api.injectEndpoints({
    endpoints: builder => ({
        getRemoteRelayStatuses: builder.query<HardwareRemoteRelay[], string>({
            query: (ipAddress: string) => ({
                url: `RemoteRelay/${ipAddress}`,
                method: 'GET'
            }),
            transformResponse: (response: { data: HardwareRemoteRelay[] }) => response.data,
            providesTags: ['RemoteRelay']
        }),
        toggleRemoteRelay: builder.mutation<HardwareRemoteRelay, ToggleRemoteRelayPayload>({
            query: (payload: ToggleRemoteRelayPayload) => ({
                url: `RemoteRelay/SetRelay/${payload.ipAddress}`,
                method: 'POST',
                body: {
                    id: payload.id,
                    toggled: payload.toggled
                }
            }),
            transformResponse: (response: { data: HardwareRemoteRelay }) => response.data,
            invalidatesTags: ['RemoteRelay']
        })
    })
});

export const { useGetRemoteRelayStatusesQuery, useToggleRemoteRelayMutation } = remoteRelayApi;